import PropTypes from 'prop-types'
import { Loading } from 'ui-components-web'
import { observer } from 'mobx-react-lite'
import PendingQueries from 'singletons/PendingQueries'

const isQueryFetching = (query) =>
  typeof query === 'string' ? PendingQueries.some(query) : PendingQueries.some(query.type, query.callback)

const QueryWaiter = ({ query, all, children }) => {
  const isFetching = Array.isArray(query)
    ? all
      ? query.every(isQueryFetching)
      : query.some(isQueryFetching)
    : isQueryFetching(query)

  if (typeof children === 'function') {
    return children(isFetching)
  }

  return isFetching ? <Loading loading /> : children || null
}

const singleQueryPropType = PropTypes.oneOfType([
  PropTypes.string,
  PropTypes.shape({
    type: PropTypes.string.isRequired,
    callback: PropTypes.func,
  }),
])

QueryWaiter.propTypes = {
  query: PropTypes.oneOfType([singleQueryPropType, PropTypes.arrayOf(singleQueryPropType)]).isRequired,
  all: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
}

export default observer(QueryWaiter)
